import { useMemo, useState } from "react";
import RuleBuilderConvert from "utils/converter/RuleBuilderConvert";

function useDynamicFieldConfig(groupData, configList, groupFilterFn) {
  const [selectedGroup, setSelectedGroup] = useState("");
  const filteredGroupFields = useMemo(() => {
    const allowedFields = groupData.filter(groupFilterFn);
    return RuleBuilderConvert.aiccRBFieldConfigToGroupedFields(allowedFields, [
      ...configList.flatMap((e) => e.aiccDataStreamJsons),
      ...configList
        .flatMap((e) => e.apiDetails ?? [])
        .map((e) => ({
          ...e,
          jsonId: e.dataStreamConfigApiId,
          jsonFileSchemaName: e.apiName,
        })),
    ]);
  }, [configList, groupData, groupFilterFn]);

  return { filteredGroupFields, selectedGroup, setSelectedGroup };
}

export default useDynamicFieldConfig;
